import data from './data'
import methods from './methods'
import components from './components'
import watch from './watch'

export default {
  data,
  methods,
  components,
  watch,

  resourcePath: 'v1/professional/agendas/agendas/'
}



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/company/gadget/components/active-agenda/resources/index.js